import { IFilter } from "@saleor/components/Filter";
import { FilterOpts, MinMax } from "@saleor/types";
import { createDateField } from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum CornermarkFilterKeys {
  created = "created"
}

export interface CornermarkListFilterOpts {
  created: FilterOpts<MinMax>;
}

const messages = defineMessages({
  created: {
    defaultMessage: "Created",
    description: "When Corner Mark Created"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: CornermarkListFilterOpts
): IFilter<CornermarkFilterKeys> {
  return [
    {
      ...createDateField(
        CornermarkFilterKeys.created,
        intl.formatMessage(messages.created),
        opts.created.value
      ),
      active: opts.created.active
    }
  ];
}
